import React from 'react'
import { Tooltip } from '@material-ui/core'
import TableValueAction from '../../../MuiTable/components/TableValueAction'
import DemorasVolcadoras from '../../containers/demorasVolcadoras/DemorasVolcadoras'
import AccessTimeIcon from '@material-ui/icons/AccessTime'

export default function DetalleDemoraPorVolcadora (props) {
  const { fecha, volcadora, filtroInicial } = props
  return (
    <TableValueAction
      value={
        <Tooltip title='Ver demoras'>
          <AccessTimeIcon />
        </Tooltip>
      }
      title={`Demora en volcadora ${volcadora}`}
      content={<DemorasVolcadoras
        filtroInicial={filtroInicial}
        fecha={fecha}
      />}
    />
  )
}
